/**
 * This barrel file provides the export for the shared NameListService.
 */
export * from './name-list.service';



// WEBPACK FOOTER //
// ./src/app/shared/name-list/index.ts